export function normalizeUpdateConfig(value = {}) {
  return {
    enabled: typeof value.enabled === 'boolean' ? value.enabled : Boolean(value.min_version),
    minimumVersion: value.minimumVersion || value.min_version || '',
    updateUrl: value.updateUrl || value.store_url || ''
  };
}
export function validateUpdateConfig(config, platform) {
  if (!config.enabled) return '';
  if (!/^\d{1,9}\.\d{1,9}\.\d{1,9}$/.test(config.minimumVersion)) return 'اكتب أقل إصدار مسموح بصيغة 1.0.0';
  try {
    const url = new URL(config.updateUrl);
    const host = platform === 'ios' ? 'apps.apple.com' : 'play.google.com';
    if (url.protocol !== 'https:' || url.hostname !== host || url.username || url.password) throw new Error();
  } catch {
    return platform === 'ios' ? 'أدخل رابط التطبيق على App Store باستخدام HTTPS.' : 'أدخل رابط التطبيق على Google Play باستخدام HTTPS.';
  }
  return '';
}
export function buildUpdatePayload(configs) {
  const payload = {};
  for (const platform of ['android', 'ios']) {
    const config = configs[platform];
    payload[`${platform}/enabled`] = config.enabled;
    payload[`${platform}/minimumVersion`] = config.minimumVersion.trim();
    payload[`${platform}/updateUrl`] = config.updateUrl.trim();
    // Compatibility with existing mobile builds, including disabling enforcement.
    payload[`${platform}/min_version`] = config.enabled ? config.minimumVersion.trim() : null;
    payload[`${platform}/store_url`] = config.updateUrl.trim() || null;
    payload[`${platform}/latest_version`] = null;
  }
  return payload;
}
